import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c2242d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "caps" }, "HOW DO I TURN OFF CAPS LOCK:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Response from server:", -1))

import { ref } from 'vue';
import axios from 'axios';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const name = ref('');
const email = ref('');
const caps = ref('');
const response = ref('');
const activeClass = 'active';

const submitForm = () => {
  axios.post('//jsonplaceholder.typicode.com/posts', {
    name: name.value,
    email: email.value,
    caps: caps.value
  }).then(responseData => {
    response.value = JSON.stringify(responseData, null, 2);
    name.value = '';
    email.value = '';
    caps.value = '';
  }).catch(error => {
    response.value = 'Error: ' + error.response.status
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          id: "name",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, name.value]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          id: "email",
          type: "email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, email.value]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_7,
        _hoisted_8,
        _withDirectives(_createElementVNode("textarea", {
          id: "caps",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((caps).value = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, caps.value]
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass([name.value&&email.value&&caps.value ? activeClass : '']),
        type: "submit"
      }, "Submit", 2),
      _createElementVNode("div", null, [
        _hoisted_9,
        _createElementVNode("pre", null, _toDisplayString(response.value), 1)
      ])
    ], 40, _hoisted_2)
  ]))
}
}

})